// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    CustomFieldCollectionOutput,
    CustomFieldCollectionOutputFromJSON,
    CustomFieldCollectionOutputToJSON,
    Requirement,
    RequirementFromJSON,
    RequirementToJSON,
    Step,
    StepFromJSON,
    StepToJSON,
    StepParsed,
    StepParsedFromJSON,
    StepParsedToJSON,
    Tag,
    TagFromJSON,
    TagToJSON,
    Upload,
    UploadFromJSON,
    UploadToJSON,
} from './';

/**
 * 
 * @export
 * @interface TestCaseRevisionReviewData
 */
export interface TestCaseRevisionReviewData {
    /**
     * 
     * @type {string}
     * @memberof TestCaseRevisionReviewData
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof TestCaseRevisionReviewData
     */
    suite?: number;
    /**
     * 
     * @type {string}
     * @memberof TestCaseRevisionReviewData
     */
    description?: string;
    /**
     * 
     * @type {Array<Step>}
     * @memberof TestCaseRevisionReviewData
     */
    steps?: Array<Step>;
    /**
     * 
     * @type {Array<StepParsed>}
     * @memberof TestCaseRevisionReviewData
     */
    stepsParsed?: Array<StepParsed>;
    /**
     * 
     * @type {number}
     * @memberof TestCaseRevisionReviewData
     */
    priority?: number;
    /**
     * 
     * @type {Array<CustomFieldCollectionOutput>}
     * @memberof TestCaseRevisionReviewData
     */
    customFields?: Array<CustomFieldCollectionOutput>;
    /**
     * 
     * @type {Array<Tag>}
     * @memberof TestCaseRevisionReviewData
     */
    tags?: Array<Tag>;
    /**
     * 
     * @type {Array<Requirement>}
     * @memberof TestCaseRevisionReviewData
     */
    requirements?: Array<Requirement>;
    /**
     * 
     * @type {Array<Upload>}
     * @memberof TestCaseRevisionReviewData
     */
    attachments?: Array<Upload>;
}

export function TestCaseRevisionReviewDataFromJSON(json: any): TestCaseRevisionReviewData {
    return {
        'title': !exists(json, 'title') ? undefined : json['title'],
        'suite': !exists(json, 'suite') ? undefined : json['suite'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'steps': !exists(json, 'steps') ? undefined : (json['steps'] as Array<any>).map(StepFromJSON),
        'stepsParsed': !exists(json, 'steps_parsed') ? undefined : (json['steps_parsed'] as Array<any>).map(StepParsedFromJSON),
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'customFields': !exists(json, 'custom_fields') ? undefined : (json['custom_fields'] as Array<any>).map(CustomFieldCollectionOutputFromJSON),
        'tags': !exists(json, 'tags') ? undefined : (json['tags'] as Array<any>).map(TagFromJSON),
        'requirements': !exists(json, 'requirements') ? undefined : (json['requirements'] as Array<any>).map(RequirementFromJSON),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] as Array<any>).map(UploadFromJSON),
    };
}

export function TestCaseRevisionReviewDataToJSON(value?: TestCaseRevisionReviewData): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'title': value.title,
        'suite': value.suite,
        'description': value.description,
        'steps': value.steps === undefined ? undefined : (value.steps as Array<any>).map(StepToJSON),
        'steps_parsed': value.stepsParsed === undefined ? undefined : (value.stepsParsed as Array<any>).map(StepParsedToJSON),
        'priority': value.priority,
        'custom_fields': value.customFields === undefined ? undefined : (value.customFields as Array<any>).map(CustomFieldCollectionOutputToJSON),
        'tags': value.tags === undefined ? undefined : (value.tags as Array<any>).map(TagToJSON),
        'requirements': value.requirements === undefined ? undefined : (value.requirements as Array<any>).map(RequirementToJSON),
        'attachments': value.attachments === undefined ? undefined : (value.attachments as Array<any>).map(UploadToJSON),
    };
}


